import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../material/material.module';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { MainHeaderComponent } from './main-layout/main-header/main-header.component';
import { SidebarMenuComponent } from './main-layout/sidebar-menu/sidebar-menu.component';

@NgModule({
	declarations: [LoginLayoutComponent, MainHeaderComponent, MainLayoutComponent, SidebarMenuComponent],
	imports: [CommonModule, RouterModule, MaterialModule],
	exports: [LoginLayoutComponent, MainLayoutComponent],
})
export class LayoutModule {}
